import IndexTable from 'main/components/navigation/index_table/IndexTable';
import IndexTableRow from 'main/components/navigation/index_table/IndexTableRow';

IndexTable.Row = IndexTableRow;

export {
  IndexTable
};
